module.exports = __webpack_public_path__ + "static/media/edit-bio.75bdccfc.svg";